import "./Buttons.css";

interface ButtonsProps {
  oneButton?: boolean;
  onClickFirst: () => void;
  onClickSecond?: () => void;
  textFirst: string;
  textSecond?: string;
}

const Buttons: React.FC<ButtonsProps> = ({
  oneButton,
  onClickFirst,
  onClickSecond,
  textFirst,
  textSecond,
}) => {
  return (
    <div className="buttons">
      <button className="button-first" onClick={onClickFirst}>
        {textFirst}
      </button>
      {oneButton !== true && onClickSecond && textSecond && (
        <button className="button-second" onClick={onClickSecond}>
          {textSecond}
        </button>
      )}
    </div>
  );
};

export default Buttons;
